import Model from '../orm/Model'
import Input from '../orm/Input'
import Travel from './Travel'

import { isEmpty } from '@/utilities'

export default class Team extends Model {
    static entity = 'teams'

    static fields() {
        return {
            id: this.attr(null),
            uuid: this.attr(''),
            name: this.attr(''),
            tag: this.attr(''),
            apa: this.attr(0),
            is_sport: this.boolean(),
            visibility: this.attr(null),
            students_count: this.number(),
            active_students_count: this.number(),
            graduated_students_count: this.number(),
            discharged_students_count: this.number(),
            travel: this.hasMany(Travel, 'team_id'),
        }
    }

    static graphql = {
        all: {
            paginated: true,
            parameters: {
                page: 'Int',
                per_page: 'Int',
                sort_by: 'String',
                sort_dir: 'String',
            },
        },
        params: {
            paginated: true,
            parameters: {
                query: 'String',
                per_page: 'Int',
            },
        },
        one: {
            type: 'team',
            parameters: {
                uuid: 'String!',
            },
        },
        create: {
            type: 'createTeam',
            parameters: {
                input: new Input('TeamInput!', [
                    'name',
                    'tag',
                    'is_sport',
                    'visibility',
                ]),
            },
        },
        update: {
            type: 'updateTeam',
            parameters: {
                id: 'Int!',
                input: new Input('TeamInput!', [
                    'name',
                    'tag',
                    'is_sport',
                    'visibility',
                ]),
            },
        },
        remove: {
            type: 'removeTeam',
            parameters: {
                id: 'Int!',
            },
        },
        bulkAttachStudents: {
            type: 'addStudentsToTeam',
            parameters: {
                team_id: 'Int!',
                student_school_ids: '[String]!',
            },
        },
    }

    static async $search(query, per_page = 5) {
        if (isEmpty(query)) return

        const { data } = await this.$fetch({
            graphql: 'params',
            variables: {
                query,
                per_page,
            },
        })

        return data
    }
}
